class Api {
  client;

  constructor(client) {
    this.client = client;
  }
}

export default Api;
